"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.DropdownMulti = DropdownMulti;
var BlockLabel_1 = require("../../../v2/components/BlockLabel");
var getBlockLabelProps_1 = require("../../../utils/getBlockLabelProps");
var mixins_1 = require("../../../themes/mixins");
var useHandleClickOutside_1 = require("../../../utils/customHooks/useHandleClickOutside");
var useScreenWidth_1 = require("../../../utils/customHooks/useScreenWidth");
var react_1 = __importStar(require("react"));
var SelectTagsInput_1 = require("../comps/SelectTagsInput");
var SelectDropdown_1 = require("../comps/SelectDropdown");
var OptionsMulti_1 = require("../comps/OptionsMulti");
var DisplayCompSingle_1 = require("../comps/DisplayCompSingle");
var handlers_1 = require("../handlers");
var useHideShowOptions_1 = require("../utils/useHideShowOptions");
var useCreateDropdownRefs_1 = require("../utils/useCreateDropdownRefs");
var keywordSearchOptions_1 = require("../utils/keywordSearchOptions");
var getValue_1 = require("../utils/getValue");
var generateOptions_1 = require("../utils/generateOptions");
var useSearchString_1 = require("../utils/useSearchString");
var styled_components_1 = require("styled-components");
var genTagComp_1 = require("../utils/genTagComp");
var styled_1 = require("../styled");
function DropdownMulti(_a) {
    var saveValueAsString = _a.saveValueAsString, valueProp = _a.value, id = _a.id, parentOnChange = _a.onChange, className = _a.className, 
    // injectOtherOption,
    readOnly = _a.readOnly, invert = _a.invert, selectClassName = _a.selectClassName, //used to override font size in priimary header
    optionsClassName = _a.optionsClassName, //used to override font size in priimary header
    selectStyleOverride = _a.selectStyleOverride, optionsFn = _a.optionsFn, optionsProp = _a.options, isTagsStyle = _a.isTagsStyle, isSearchable = _a.isSearchable, searchFieldsConfig = _a.searchFieldsConfig, setFilteredOptionsInParent = _a.setFilteredOptions, setSearchStringInParent = _a.setSearchString, searchStringInParent = _a.searchString, label = _a.label, optionsModalLabel = _a.optionsModalLabel, genCreateTagButton = _a.genCreateTagButton, placeholder = _a.placeholder, genCustomSelectComp = _a.genCustomSelectComp, disableSelectTextUpdate = _a.disableSelectTextUpdate, selectConfig = _a.selectConfig, 
    //props whose existence needs to be questioned:
    lightboxHeight = _a.lightboxHeight, lightboxStyle = _a.lightboxStyle, optionsAnchor = _a.optionsAnchor, popOutOfOverflowHiddenParent = _a.popOutOfOverflowHiddenParent, S = _a.S, disabled = _a.disabled, broadcastShowOptions = _a.broadcastShowOptions, tagColor = _a.tagColor, searchbarPlaceholder = _a.searchbarPlaceholder, _b = _a.alignDropdown, alignDropdown = _b === void 0 ? "left" : _b;
    var theme = (0, styled_components_1.useTheme)();
    var props = arguments[0];
    var value = (0, getValue_1.getValue_MULTI)({ valueProp: valueProp, optionsFn: optionsFn, options: optionsProp, theme: theme, saveValueAsString: saveValueAsString });
    //1 INIT REFS
    var _c = (0, useCreateDropdownRefs_1.useCreateDropdownRefs)(), selectRef = _c.selectRef, dropdownRef = _c.dropdownRef;
    //2 INIT SHOW OPTIONS STATE
    var _d = (0, useHideShowOptions_1.useHideShowOptions)({
        broadcastShowOptions: broadcastShowOptions
    }), showOptions = _d.showOptions, handleHideOptions = _d.handleHideOptions, handleShowOptions = _d.handleShowOptions;
    var screenWidth = (0, useScreenWidth_1.useScreenWidth)();
    //3 INIT DD FOCUS CUSTOM HOOK
    (0, useHandleClickOutside_1.useHandleClickOutside)(dropdownRef, handleHideOptions, { enabled: screenWidth >= (0, mixins_1.getBreakPoint)('sm') });
    //-- TAG INPUT SPECIFIC
    var _e = (0, useSearchString_1.useSearchString)({
        setSearchStringInParent: setSearchStringInParent,
        searchStringInParent: searchStringInParent
    }), searchString = _e[0], setSearchString = _e[1];
    console.log({
        optionsFn: optionsFn === null || optionsFn === void 0 ? void 0 : optionsFn.fn,
        argsString: JSON.stringify(optionsFn === null || optionsFn === void 0 ? void 0 : optionsFn.args),
    });
    var options = (0, react_1.useMemo)(function () {
        var ops = (0, generateOptions_1.generateOptions)({
            options: optionsProp,
            optionsFn: optionsFn,
            theme: theme
            // injectOtherOption,
        });
        console.log({ ops: ops });
        var currentValue = value || [];
        // rm the selectedOps from ops list (since they are shown anyway in the selectedops list)
        return /*isTagsStyle ? ops : */ ops.filter(function (op) { return currentValue.every(function (v) { return v.value !== op.value; }); });
    }, [
        JSON.stringify(optionsProp), //we need this cuz options change from 'loading' to actual options in some cases
        // showOptions
        optionsFn === null || optionsFn === void 0 ? void 0 : optionsFn.fn,
        JSON.stringify(optionsFn === null || optionsFn === void 0 ? void 0 : optionsFn.args),
        value
    ]);
    options = (0, react_1.useMemo)(function () {
        return (!isSearchable && !isTagsStyle)
            ? options
            : (0, keywordSearchOptions_1.keywordSearchOptions)({
                options: options,
                searchString: searchString,
                searchFieldsConfig: searchFieldsConfig,
                setFilteredOptionsInParent: setFilteredOptionsInParent,
            });
    }, [
        searchString,
        // showOptions, 
        options,
        value
    ]);
    /**
     * very importnant to understand:
     * Assume this second useMemo didnt have 'options' in its dependency array
     * Lets assume initial state of options from previous render is length = 8
     * If options change because of the first useMemo, (and lets say become of length 5)
     * and lets say second memo doesnt fire cuz showOptions or searchString dont change,
     * then the second useMemo sets the 'options' to its previous value in previous render (which is length = 8)
     *
     * obviously this causes bugs.
     * so by putting options in the second useMemo dependency, we force the second one to fire
     * if the options change
     */
    //--
    //5 PRIMARY CHANGE HANDLER
    var handleSelect = function (newVal) { return (0, handlers_1.handleSelect_MULTI)({
        parentOnChange: parentOnChange,
        id: id,
        newVal: newVal,
        prevVal: value,
        parentOnChange: parentOnChange,
        // hideShowOtherTextInputOnSelect_MULTI,
        saveValueAsString: saveValueAsString
    }); };
    var genDisplayComp = function () {
        if (!(value === null || value === void 0 ? void 0 : value.length) > 0)
            return null;
        return isTagsStyle ? (react_1.default.createElement(styled_1.StyledTagsInputWrapper, null, value.map(function (d) { return (0, genTagComp_1.genTagComp)(id, d, { display: true, invert: invert, theme: theme, color: tagColor }); }))) : (react_1.default.createElement("div", { style: { display: "flex", flexWrap: "wrap", gap: "0.5rem" } }, value.map(function (v, i) { return (react_1.default.createElement(react_1.Fragment, null,
            react_1.default.createElement(DisplayCompSingle_1.DisplayCompSingle, { value: v, invert: invert, injectComma: i !== value.length - 1, S: S }))); })));
    };
    var _f = (0, react_1.useState)(false), focusSelectTagsInput = _f[0], setFocusSelectTagsInput = _f[1];
    var genSelectTagsInput = function (ops) {
        if (ops === void 0) { ops = {}; }
        return (react_1.default.createElement(SelectTagsInput_1.SelectTagsInput, { id: id, value: value, invert: invert, handleSelect: handleSelect, searchString: searchString,
            setSearchString: setSearchString,
            single_multi: "multi", placeholder: placeholder, focusSelectTagsInput: focusSelectTagsInput, setFocusSelectTagsInput: setFocusSelectTagsInput, showOptions: showOptions, S: S, disabled: disabled, style: ops.style }));
    };
    var genInputComp = function () {
        // const SelectComp = isTagsStyle ? SelectTagsInput : SelectDropdown 
        return (react_1.default.createElement(styled_1.StyledDropdownRefWrapper, { ref: dropdownRef },
            react_1.default.createElement("div", { ref: selectRef, className: "OKE-Dropdown__Select-wrapper", onClick: disabled ? function () { } : function () {
                    isTagsStyle
                        ? !showOptions && handleShowOptions() //if tagsStyle, then click always shows options
                        : showOptions ? handleHideOptions() : handleShowOptions(); //if dropdowns, then click toggles show/hide
                } }, isTagsStyle ? genSelectTagsInput() : (react_1.default.createElement(SelectDropdown_1.SelectDropdown, { invert: invert, value: value, placeholder: placeholder, selectClassName: selectClassName, selectStyleOverride: selectStyleOverride, showOptions: showOptions, genCustomSelectComp: genCustomSelectComp, disableSelectTextUpdate: disableSelectTextUpdate, selectConfig: selectConfig, S: S, disabled: disabled }))),
            react_1.default.createElement(OptionsMulti_1.OptionsMulti, { searchbarPlaceholder: searchbarPlaceholder, id: id, value: value, relativeToRef: selectRef, showOptions: showOptions, handleSelect: handleSelect, handleHideOptions: handleHideOptions, optionsClassName: optionsClassName, options: options, optionsFn: optionsFn, isSearchable: isTagsStyle ? false : isSearchable, searchString: searchString, setSearchString: setSearchString, label: label, optionsModalLabel: optionsModalLabel, isTagsStyle: isTagsStyle, genCreateTagButton: genCreateTagButton, lightboxHeight: lightboxHeight, lightboxStyle: lightboxStyle, optionsAnchor: optionsAnchor, SelectComp: isTagsStyle && genSelectTagsInput({ style: { position: 'sticky', top: 0, zIndex: 1000 } }), invert: invert, setFocusSelectTagsInput: setFocusSelectTagsInput, popOutOfOverflowHiddenParent: popOutOfOverflowHiddenParent, S: S, alignDropdown: alignDropdown })));
    };
    return (react_1.default.createElement("div", { className: "OKE-Dropdown ".concat(className, " OKE-Dropdown--").concat(readOnly ? "displayComp" : "inputComp", " ").concat(invert ? "-invert-" : "") },
        react_1.default.createElement(BlockLabel_1.BlockLabel, __assign({}, (0, getBlockLabelProps_1.getBlockLabelProps)(props))),
        readOnly ? genDisplayComp() : genInputComp()));
}
